import { type CellWidthStyle } from "./Cell";

export const cellStyleWidth3: CellWidthStyle = { width: "33.333333%" };

export const cellStyleWidth4: CellWidthStyle = { width: "25%" };

export const cellStyleWidth7: CellWidthStyle = { width: "14.285714%" };
